import { createRouter,
  createWebHashHistory,
} from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { setupRouterGuards } from './guards'

export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/login/index.vue'),
    meta: { title: '登录', hidden: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '404', hidden: true },
  },
]

export const asyncRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: { title: '首页' },
    children: [
      {
        path: 'member',
        name: 'Member',
        meta: { title: '会员管理', icon: 'User' },
        children: [
          {
            path: 'user',
            name: 'MemberUser',
            component: () => import('@/views/member/user/index.vue'),
            meta: { title: '用户管理' },
          },
        ],
      },
      {
        path: 'store',
        name: 'Store',
        meta: { title: '商家与门店', icon: 'Shop' },
        children: [
          {
            path: 'list',
            name: 'StoreList',
            component: () => import('@/views/store/list/index.vue'),
            meta: { title: '门店列表' },
          },
          {
            path: 'account',
            name: 'StoreAccount',
            component: () => import('@/views/store/account/index.vue'),
            meta: { title: '商家账号' },
          },
          {
            path: 'allinpay-merchant',
            name: 'StoreAllinpayMerchant',
            component: () => import('@/views/store/allinpay-merchant/index.vue'),
            meta: { title: '通联商户号' },
          },
        ],
      },
      {
        path: 'order',
        name: 'Order',
        meta: { title: '订单管理', icon: 'List' },
        children: [
          {
            path: 'list',
            name: 'OrderList',
            component: () => import('@/views/order/list/index.vue'),
            meta: { title: '订单列表' },
          },
        ],
      },
      {
        path: 'drink',
        name: 'Drink',
        meta: { title: '奶茶管理', icon: 'Coffee' },
        children: [
          {
            path: 'recipe',
            name: 'DrinkRecipe',
            component: () => import('@/views/drink/recipe/index.vue'),
            meta: { title: '奶茶配方' },
          },
          {
            path: 'category',
            name: 'DrinkCategory',
            component: () => import('@/views/drink/category/index.vue'),
            meta: { title: '奶茶分类' },
          },
          {
            path: 'topping',
            name: 'DrinkTopping',
            component: () => import('@/views/drink/topping/index.vue'),
            meta: { title: '小料设置' },
          },
          {
            path: 'material',
            name: 'DrinkMaterial',
            component: () => import('@/views/drink/material/index.vue'),
            meta: { title: '原料设置' },
          },
        ],
      },
      {
        path: 'marketing',
        name: 'Marketing',
        meta: { title: '营销管理', icon: 'Present' },
        children: [
          {
            path: 'coupon',
            name: 'MarketingCoupon',
            component: () => import('@/views/marketing/coupon/index.vue'),
            meta: { title: '用户卡券' },
          },
          {
            path: 'banner',
            name: 'MarketingBanner',
            component: () => import('@/views/marketing/banner/index.vue'),
            meta: { title: '轮播图' },
          },
        ],
      },
      {
        path: 'finance',
        name: 'Finance',
        meta: { title: '财务管理', icon: 'Money' },
        children: [
          {
            path: 'withdraw',
            name: 'FinanceWithdraw',
            component: () => import('@/views/finance/withdraw/index.vue'),
            meta: { title: '商户提现' },
          },
          {
            path: 'pre-transfer',
            name: 'FinancePreTransfer',
            component: () => import('@/views/finance/pre-transfer/index.vue'),
            meta: { title: '预转账' },
          },
          {
            path: 'partner-withdraw',
            name: 'FinancePartnerWithdraw',
            component: () => import('@/views/finance/partner-withdraw/index.vue'),
            meta: { title: '合伙人提现' },
          },
          {
            path: 'legal-person',
            name: 'FinanceLegalPerson',
            component: () => import('@/views/finance/legal-person/index.vue'),
            meta: { title: '法人信息' },
          },
        ],
      },
      {
        path: 'payment',
        name: 'Payment',
        meta: { title: '支付管理', icon: 'Wallet' },
        children: [
          {
            path: 'withdraw-reconcile',
            name: 'PaymentWithdrawReconcile',
            component: () => import('@/views/payment/withdraw-reconcile/index.vue'),
            meta: { title: '提现对账' },
          },
          {
            path: 'order-reconcile',
            name: 'PaymentOrderReconcile',
            component: () => import('@/views/payment/order-reconcile/index.vue'),
            meta: { title: '订单对账' },
          },
        ],
      },
      {
        path: 'system',
        name: 'System',
        meta: { title: '系统管理', icon: 'Setting' },
        children: [
          {
            path: 'admin',
            name: 'SystemAdmin',
            component: () => import('@/views/system/admin/index.vue'),
            meta: { title: '管理员账号' },
          },
        ],
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
  scrollBehavior: () => ({ top: 0 }),
})

setupRouterGuards(router)

export default router
